export const INVESTOR_QUERY_KEYS = ["redirect", "intent", "itemId", "tab", "filter"];

/**
 * Read investor deep-link params from React Router search params or URLSearchParams.
 */
export function getInvestorQueryParams(searchParams) {
  const get = (key) => {
    if (!searchParams) return "";
    if (typeof searchParams.get === "function") {
      return searchParams.get(key) || "";
    }
    return searchParams[key] || "";
  };

  return {
    redirect: get("redirect"),
    intent: get("intent"),
    itemId: get("itemId"),
    tab: get("tab"),
    filter: get("filter"),
  };
}

/**
 * Build a query string preserving redirect / intent / itemId.
 */
export function buildInvestorQueryString({ redirect, intent, itemId, tab, filter } = {}) {
  const params = new URLSearchParams();
  if (redirect) params.set("redirect", redirect);
  if (intent) params.set("intent", intent);
  if (itemId) params.set("itemId", itemId);
  if (tab) params.set("tab", tab);
  if (filter) params.set("filter", filter);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

/**
 * Append preserved investor params to a portal path.
 */
export function withInvestorQuery(path, query = {}) {
  const qs = buildInvestorQueryString(query);
  return `${path}${qs}`;
}

/** Deep-link params to carry when returning after KYC (excludes tab). */
export function pickInvestorReturnQuery(query = {}) {
  const { redirect, intent, itemId, filter } = query;
  return { redirect, intent, itemId, filter };
}

/** Profile → Identity verification tab, preserving invest deep-link params. */
export function withProfileVerificationQuery(query = {}) {
  return withInvestorQuery("/invest/profile", { ...query, tab: "verification" });
}
